'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { TextRevealSection } from '../TextRevealSection';

/**
 * Black statement band that follows the lead form. Reuses the recovery page's
 * scroll-driven word-by-word reveal (grey → white) via TextRevealSection.
 */
export const IvLoungeStatementSection: React.FC = () => {
  const t = useTranslations('performance-lab');

  return (
    <TextRevealSection
      ariaLabel={t('ivLounge.statement.aria')}
      bodyText={t('ivLounge.statement.body')}
      backgroundColor="#000"
      textColor="#fff"
      scrollTrackVhMobile={2}
      scrollTrackVhDesktop={3}
    />
  );
};
